import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './components/Header';

function About() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div style={{
      //minHeight: '100vh',
      background: '#FFFFFF',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif'
    }}>
      <Header />
      
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '40px 20px'
      }}>
        {/* 뒤로가기 버튼 */}
        <button
          onClick={() => navigate(-1)}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: '#2C3E50',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            marginBottom: '30px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 0'
          }}
        >
          ← {t('about.back')}
        </button>

        {/* 메인 카드 */}
        <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '4px solid #2C3E50',
          padding: '40px',
          boxShadow: '8px 8px 0px #2C3E50'
        }}>
          {/* 로고 */}
          <div style={{
            fontSize: '48px',
            textAlign: 'center',
            marginBottom: '20px'
          }}>
            👋
          </div>

          {/* 제목 */}
          <h1 style={{
            fontSize: '36px',
            fontWeight: '700',
            color: '#2C3E50',
            textAlign: 'center',
            margin: '0 0 30px 0'
          }}>
            PickFlip
          </h1>

          {/* 설명 */}
          <p style={{
            fontSize: '18px',
            color: '#7F8C8D',
            textAlign: 'center',
            lineHeight: '1.8',
            marginBottom: '40px'
          }}>
            {t('about.description')}
          </p>

          {/* 구분선 */}
          <div style={{
            height: '2px',
            backgroundColor: '#ECF0F1',
            margin: '40px 0'
          }} />

          {/* 제작 */}
          <div style={{
            textAlign: 'center',
            marginBottom: '30px'
          }}>
            <p style={{
              fontSize: '14px',
              color: '#95A5A6',
              marginBottom: '8px',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              {t('about.madeBy')}
            </p>
            <p style={{
              fontSize: '20px',
              fontWeight: '700',
              color: '#2C3E50',
              margin: 0
            }}>
              너풀너풀 스튜디오
            </p>
            <p style={{
              fontSize: '16px',
              color: '#7F8C8D',
              margin: '4px 0 0 0'
            }}>
              Nuhpul Studio
            </p>
          </div>

          {/* 연락처 */}
          <div style={{
            backgroundColor: '#FFF5E6',
            borderRadius: '12px',
            padding: '24px',
            border: '2px solid #2C3E50',
            marginBottom: '30px'
          }}>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '700',
              color: '#2C3E50',
              margin: '0 0 16px 0',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              📧 {t('about.contact')}
            </h3>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              <a
                href="mailto:hello@nuhpul.com"
                style={{
                  color: '#2C3E50',
                  textDecoration: 'none',
                  fontSize: '16px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <span>💌</span>
                <span>hello@nuhpul.com</span>
              </a>
              
              <p style={{
                margin: 0,
                fontSize: '14px',
                color: '#7F8C8D',
                lineHeight: '1.6'
              }}>
                {t('about.contactMessage')}
              </p>
            </div>
          </div>

          {/* 푸터 */}
          <div style={{
            textAlign: 'center',
            paddingTop: '20px',
            borderTop: '1px solid #ECF0F1'
          }}>
            <p style={{
              fontSize: '14px',
              color: '#95A5A6',
              margin: 0
            }}>
              © 2026 Nuhpul Studio. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;